/** Distinguish an actual model change from direct providers recording the same intended model. */
export default function CompletionEngine({ engine, intendedEngine, provider }: { engine?: string | null; intendedEngine?: string | null; provider?: string | null }) {
  const usedFallback = Boolean(intendedEngine && engine && intendedEngine !== engine);
  return (
    <div className={`w-full p-3 rounded border text-sm ${usedFallback ? "bg-amber-50 border-amber-200" : "bg-white border-gray-200"}`}>
      <span className="font-medium text-gray-700">Engine:</span>
      {usedFallback ? (
        <span className="ml-2">
          <span className="text-gray-500 line-through">{intendedEngine}</span>
          <span className="text-amber-600 mx-1">→</span>
          <span className="text-amber-800 font-medium">{engine}</span>
          <span className="ml-2 text-xs text-amber-600">(Fallback)</span>
        </span>
      ) : (
        <span className="text-gray-900 ml-2">{engine || "Unknown"}</span>
      )}
      {provider && (
        <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-200">{provider}</span>
      )}
    </div>
  );
}
